// import constants from "constants";
/**
 * Gets the number of weeks in a month
 * @param year
 * @param month
 */
export function weeksInMonth(year, month) {
    const firstDay = new Date(year, month, 1).getDay();
    const totalDays = new Date(year, month + 1, 0).getDate();
    return Math.ceil((firstDay + totalDays) / 7);
}
/** Gets number of days in a month */
export function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
/**
 * Returns which day (monday, tuesday, etc..) a specific day is
 * @param year
 * @param month
 * @param day
 */
export function dayOfWeek(year, month, day) {
    return new Date(year, month, day).getDay();
}
/** Gets the first day of the specified week. Can return a day from a different month */
export function firstDayOfWeek(year, month, week) {
    const checkDate = 1 + (7 * week);
    const day = dayOfWeek(year, month, checkDate);
    return new Date(year, month, checkDate - day);
}
export function lastDayOfWeek(year, month, week) {
    const checkDate = 1 + (7 * week);
    const day = dayOfWeek(year, month, checkDate);
    return new Date(year, month, (checkDate - day) + 6);
}
/** Returns an array with a date for each day in a week */
export function daysOfWeek(year, month, week) {
    const first = firstDayOfWeek(year, month, week);
    const days = Array(7).fill(null).map((val, i) => new Date(first.getFullYear(), first.getMonth(), first.getDate() + i));
    return days;
}
export function weekOfDay(day) {
    return Math.floor(day / 7);
}
//# sourceMappingURL=calendar-util.js.map